import { ErrorHandler, Injectable, Injector } from '@angular/core'
// import { Logger } from '@app/core/logger.service';
import { ErrorService } from './ErrorService'
// import { NotificationService } from '@app/notification.service';
import { ApploggerService } from './core/services/applogger.service'
import { HttpErrorResponse } from '@angular/common/http'

// const logger = new Logger('GlobalErrorHandler');

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private appLoggerService: ApploggerService,
    private injector: Injector,
  ) {}
  protected hasWindow(): boolean {
    return typeof window !== 'undefined'
  }
  handleError(error: Error) {
    const errorService = this.injector.get(ErrorService)
    let message
    let stackTrace
    let screenId

    if (error instanceof HttpErrorResponse) {
      screenId = error.name
    } else {
      // Client Error
      screenId = 'ClientSide'
      message = errorService.getClientMessage(error)
      stackTrace = errorService.getClientStack(error)
      // remove system errors from toast
      // this.notifier.notify('error', message)
      // this.notificationService.showToastMessage(message, 5000);
    }
    // Always log errors
    // console.info(message);
    // logger.error(message, stackTrace);
    console.warn(message)
    console.warn(stackTrace)
    if (this.hasWindow()) {
      // console.log(window)
      // console.log('window')
      this.appLoggerService.LogWarn(window?.location?.href, error.message, stackTrace, screenId, null)
    }
  }
}
